import { render, staticRenderFns } from "./quick-access.vue?vue&type=template&id=2de9d11f&scoped=true&"
import script from "./quick-access.component.ts?vue&type=script&lang=js&"
export * from "./quick-access.component.ts?vue&type=script&lang=js&"
import style0 from "./quick-access.vue?vue&type=style&index=0&id=2de9d11f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9d11f",
  null
  
)

export default component.exports